import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
  const [organisationName, setOrganisationName] = React.useState("");
  const [validityExpired, setValidityExpired] = React.useState(false);

  const [open, setOpen] = React.useState(false);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function goToLocation(){ 
    setOpen(false);
    props.toCallStartTest();
	}

  React.useEffect(() => {		
		if(open && props.testDetail && props.testDetail.patternDetails){

      setOrganisationName(mySelectedCourses[selectedCourse].organisationName);
      var d1 = new Date();
      var d2 = new Date(mySelectedCourses[selectedCourse].validTillDate);
      d2.setDate(d2.getDate() + 1);
      ////alert("Date>> "+d1.getFullYear()+"-"+d1.getMonth()+"-"+d1.getDate()); 
      if(d1>d2 && mySelectedCourses[selectedCourse].packTypeTitle.indexOf("FREE")===-1){
        setValidityExpired(true);      
      }else{
        setValidityExpired(false);
      }      

		}
	}, [open,props.testDetail]); 

  function upgradeNow(){
    if(mySelectedCourses && selectedCourse>-1){
      window.location.href="selectcourse?cid="+mySelectedCourses[selectedCourse].courseId;
    }
  }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent>
          {(props.testDetail!=null && props.testDetail.patternDetails!=null)?
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.testDetail.mockTestTitle}</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="5" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total Questions</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.patternDetails.totalQuestion}</td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total time for Test(minutes)</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.patternDetails.totalTime}</td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Question Type</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.patternDetails.questionType}</td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Marks for correct answer</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.patternDetails.markCorrectAns}</td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Marks for incorrect answer</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.patternDetails.markIncorrectAns}</td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Marks for questions not attempted</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.patternDetails.markNotAttempt}</td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total Marks</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.patternDetails.totalMark}</td>
                        </tr>
                      </table>

                      {validityExpired?      
                     <Box mt={2} >
                      <h2 style={{textAlign:'center',color:'#FF0000',fontWeight:'bold'}}>
                        {(organisationName && organisationName.length>0)?<>{organisationName}'s</>:null} validity has been finished. Renew your account to continue your practice.
                        </h2> 
                     </Box>     
                    :null}

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:20}} size="small" variant="outlined" >Cancel</Button>
                          {validityExpired?
                            <Button title="Renew Now" variant="contained" onClick={() => {upgradeNow()}} size="small" style={{textTransform:'none',backgroundColor:'#008140',color:'#FFF'}} >Renew Now</Button>
					    	          :<Button onClick={() => {goToLocation()}} size="small" variant="contained" color="secondary" >Start Test</Button>
                          }  
                      </Box>

                  </p>
            </Grid>
          :null}  
          </DialogContent>
      </Dialog>
    </>
  );

});

export default CustomizedDialogs;